import {lazyRegister} from '@/Core/lazyRegister';
import './input-date.component.css';
import template from './input-date.component.html';

class InputDateController implements ng.IController {
    static $inject = [
        '$element',
        '$scope',
        '$timeout'
    ];
    value?: string;
    modelValue?: Date;
    model?: string;
    onChange: (params: { $event: string }) => void;

    constructor(private readonly $element,
                private readonly $scope: ng.IScope,
                private readonly $timeout: ng.ITimeoutService,
    ) {
    }

    $onInit(): void {
        this.$element.addClass('input-date');
        this.modelValue = this.toDate(this.value || this.model);
    }

    $onChanges(changes: ng.IOnChangesObject): void {
        if (changes.value && !changes.value.isFirstChange()) {
            this.modelValue = this.toDate(changes.value.currentValue);
        }
    }

    private toDate(value?: string | Date): Date | undefined {
        if (!value) {
            return undefined;
        }

        if (value instanceof Date) {
            return value;
        }

        const [year, month, day] = value.split('-').map(Number);
        if ([year, month, day].every(Number.isFinite)) {
            return new Date(year, month - 1, day);
        }

        return undefined;
    }

    handleValueChange(): void {
        const inputControl = this.$element[0].querySelector('input');
        this.model = inputControl.value;
        
        if (this.onChange) {
            this.$timeout(() => {
                this.onChange({$event: this.model});
            });
        }
    }
}

export const InputDateComponent: ng.IComponentOptions = {
    bindings: {
        value: '<?',
        model: '=?',
        onChange: '&?'
    },
    template: template,
    controller: InputDateController
};

lazyRegister.component('inputDate', InputDateComponent);
